import { __rest } from "tslib";
import clsx from 'clsx';
import React from 'react';
const LinearProgress = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("div", Object.assign({}, props, { ref: ref, className: clsx('linear-progress', className) }),
        React.createElement("span", { className: 'linear-progress-root', role: 'progressbar' },
            React.createElement("span", { className: 'linear-progress-bar-1' }),
            React.createElement("span", { className: 'linear-progress-bar-2' }))));
});
LinearProgress.displayName = 'LinearProgress';
export { LinearProgress };
//# sourceMappingURL=index.js.map